export default "__VITE_ASSET__BljojOfw__"